// src/config/dates.js

// Season dates (fallback defaults - use SettingsContext for dynamic values)
export const SEASON_CONFIG = {
  SEASON_START: '2026-05-10',
  SEASON_END: '2026-09-07',
  EVENING_TIMES_CHANGE_DATE: '2026-08-14',
  REGISTRATION_VERSION: 'v2.0',
  REGISTRATION_YEAR: '2026'
};

// Safety officer training dates and deadlines (fallback defaults - use SettingsContext for dynamic values)
export const SAFETY_OFFICER_DATES = {
  FIRST_OFFICER: {
    TRAINING_YEAR: '2026',
    TRAINING_DAY: '1 March 26 (9am-5pm)',
    POOL_SESSIONS: [
      { DATE: '8 March 26', TIME: '10am-12pm' },
      { DATE: '15 March 26', TIME: '10am-12pm' }
    ],
    REGISTRATION_DEADLINE: '2026-03-14',
    DISCOUNT_PERCENTAGE: 50
  },
  SECOND_OFFICER: {
    THEORY_SESSIONS: [
      { DATE: '4 March 26', TIME: '7:30-9:30pm' },
      { DATE: '11 March 26', TIME: '7:30-9:30pm' }
    ],
    POOL_SESSIONS: [
      { DATE: '6 April 26', TIME: '11:15-12:15am' },
      { DATE: '13 April 26', TIME: '11:15-12:15am' }
    ],
    REGISTRATION_DEADLINE: '2026-04-24'
  }
};

// Opening times
export const OPENING_TIMES = {
  REGULAR: {
    EVENING: {
      START: '18:30',
      END: '20:30',
      LATE_SEASON_END: '19:45' // After August 14
    },
    WEEKEND: {
      START: '15:00',
      END: '17:00'
    }
  },
  SCHOOL_HOLIDAYS: {
    START: '14:30',
    END: '16:30'
  }
};

// Utility functions for deadline checks
export const isFirstSafetyOfficerDeadlinePassed = () => {
  const deadline = new Date(SAFETY_OFFICER_DATES.FIRST_OFFICER.REGISTRATION_DEADLINE);
  return new Date() > deadline;
};

export const isSecondSafetyOfficerDeadlinePassed = () => {
  const deadline = new Date(SAFETY_OFFICER_DATES.SECOND_OFFICER.REGISTRATION_DEADLINE);
  return new Date() > deadline;
};

// Utility function to get default duty type based on deadlines
export const getDefaultDutyType = (currentValue) => {
  const firstDeadlinePassed = isFirstSafetyOfficerDeadlinePassed();
  const secondDeadlinePassed = isSecondSafetyOfficerDeadlinePassed();

  if (currentValue === '1st Safety Officer' && firstDeadlinePassed) {
    return 'Administrator';
  }
  if (currentValue === '2nd Safety Officer' && secondDeadlinePassed) {
    return 'Administrator';
  }
  return currentValue || 'Administrator';
};

// Function to format time for display (removes seconds if present)
const formatTime = (time) => {
  if (!time) return '';
  // Remove seconds if present (e.g., "18:30:00" -> "18:30")
  const parts = time.split(':');
  return parts.slice(0, 2).join(':');
};

// Function to format time ranges for display
export const formatTimeRange = (start, end) => {
  return `${formatTime(start)}-${formatTime(end)}`;
};

// Function to get current session end time based on date
export const getSessionEndTime = (date) => {
  const changeDate = new Date(SEASON_CONFIG.EVENING_TIMES_CHANGE_DATE);
  const checkDate = new Date(date);
  
  return checkDate > changeDate 
    ? OPENING_TIMES.REGULAR.EVENING.LATE_SEASON_END 
    : OPENING_TIMES.REGULAR.EVENING.END;
};